import svgFiles from '@/assets/svg/svgFiles';
import LoadingPage from '@/components/templates/LoadingPage';
import { Image, Text, VStack } from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';

type Props = {
  isLoading?: boolean;
  name?: string;
  profileImage?: string;
  role?: string;
  roleColor?: string;
  designation?: string;
  description?: string;
};

const DirectoryProfileViewPageTemplate = ({
  isLoading,
  children,
  profileImage,
  name,
  role,
  roleColor = 'text.mediumBlue',
  designation,
  description,
}: PropsWithChildren<Props>) => {
  if (isLoading) return <LoadingPage />;

  return (
    <VStack width={'500px'} marginBottom={'50px'}>
      <VStack
        borderWidth={'4px'}
        borderRadius={'full'}
        borderColor={'white'}
        shadow={'0px 6px 24px 0px rgba(14, 0, 98, 0.2)'}
        overflow={'hidden'}
        minHeight={'120px'}
      >
        <Image
          src={profileImage ?? svgFiles.genericUser}
          alt={name}
          width={120}
          height={120}
          borderRadius={'full'}
          objectFit={'cover'}
          style={{ backgroundColor: 'white' }}
        />
      </VStack>
      <Text variant={'loraSmallTitle'} marginTop={'10px'}>
        {name}
      </Text>
      <Text variant={'urbanistSemiBold'} color={roleColor}>
        {role}
      </Text>
      {designation && (
        <Text variant={'urbanistSemiBoldRegular'} color={'text.mediumBlue'} noOfLines={3} maxWidth={400}>
          {designation}
        </Text>
      )}
      {description && (
        <Text variant={'urbanistRegular'} color={'text.mediumGray'}>
          {description}
        </Text>
      )}
      {children}
    </VStack>
  );
};

export default DirectoryProfileViewPageTemplate;
